module.exports = __webpack_public_path__ + "img/banner_gamardzhoba-big.cbc44e3.JPG";